import {
  SHOP_OWNER_EXPIRE_SESSION_SUCCESS,
  SHOP_DISABLE_REQUEST_OTP_SUCCESS,
  SHOP_UNBLOCK_INIT_REQUEST_SUCCESS,
  SHOP_LOGIN_DISABLE_REVERT_SUCCESS,
} from "actions";

export const shop = (previousState = {}, { type, payload }) => {
  if (type === SHOP_OWNER_EXPIRE_SESSION_SUCCESS) {
    return payload;
  } else if (type === SHOP_LOGIN_DISABLE_REVERT_SUCCESS) {
    return {
      ...payload,
      reverted: true,
    };
  } else if (type === SHOP_DISABLE_REQUEST_OTP_SUCCESS) {
    return {
      ...previousState,
      shop_disable_otp_verify: payload,
    };
  } else if (type === SHOP_UNBLOCK_INIT_REQUEST_SUCCESS) {
    return {
      ...previousState,
      shop_unblock_otp_verify: payload,
    };
  }

  return previousState;
};



// WEBPACK FOOTER //
// ./src/reducers/shop/index.js